"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = "linear-gradient(rgba(0,0,0, 0),rgba(0,0,0,0.15))";
exports.darkHover = "linear-gradient(rgba(0,0,0, 0.15),rgba(0,0,0,0.2))";
exports.darkSelected = "linear-gradient(rgba(0,0,0, 0.6),rgba(0,0,0,0.3))";
exports.lightHover = "#fbfbfb";
exports.lightSelected = "#ffffff";



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/navbar/interfaces.js
// module id = 509
// module chunks = 0